import { CategoryFilter, ProjectCategory, SortOption } from '../types';

export const PROJECT_CATEGORIES: readonly ProjectCategory[] = ['app', 'tool', 'template'] as const;

export const CATEGORY_FILTERS: readonly CategoryFilter[] = ['all', ...PROJECT_CATEGORIES] as const;

export const SORT_OPTIONS: readonly SortOption[] = ['recent', 'popular', 'name'] as const;

export const DEFAULT_FILTERS = {
    searchQuery: '',
    category: 'all' as CategoryFilter,
    sortBy: 'recent' as SortOption,
} as const;

// Export environment-aware mock projects getter
export { getMockProjects, MOCK_PROJECTS_DEV, MOCK_PROJECTS_PROD } from './mockProjects';
